import { defineStore } from 'pinia'
import { api } from '@/lib/api'

export const useBoardStore = defineStore('board', {
  // `loaded` separa cold load (sem dado, mostra spinner) de refresh (dado quente
  // em cache, revalida em silêncio). Pinia é singleton: ao remontar o KanbanPage
  // como fundo do modal, os tickets continuam aqui — não há motivo pra piscar.
  state: () => ({ columns: [], tickets: [], loading: false, loaded: false }),
  actions: {
    async fetch() {
      this.loading = true
      try {
        const res = await api('/api/board')
        if (!res.ok) throw new Error('Falha ao carregar o board')
        const data = await res.json()
        this.columns = data.columns
        this.tickets = data.tickets
        this.loaded = true
      } finally {
        this.loading = false
      }
    },

    // Mover card = aplicar mudanças (status, etc.). Em falha, recarrega.
    async moveTicket(ticketId, changes) {
      const res = await api(`/api/tickets/${ticketId}`, {
        method: 'PATCH',
        body: { ticket: changes },
      })
      if (!res.ok) {
        await this.fetch()
        return false
      }
      return true
    },

    // Realtime: upsert do card (normaliza account/assignee p/ o shape do board).
    applyRealtime(ticket) {
      const card = {
        ...ticket,
        account: ticket.account?.name,
        assignee: ticket.assignee?.name,
      }
      const idx = this.tickets.findIndex(t => t.id === ticket.id)
      this.tickets =
        idx >= 0
          ? this.tickets.map((t, i) => (i === idx ? { ...t, ...card } : t))
          : [...this.tickets, card]
    },
  },
})
